<div *ngIf="isLoading" class="shimmer-overlay">
  <lib-loading-shimmer [width]="shimmerWidth" [height]="shimmerHeight" [borderRadius]="shimmerBorderRadius" />
</div>
<div [class.is-loading-content]="isLoading">
  <ng-content></ng-content>
</div>
